/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NextAppointmentDate/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NextAppointmentDate({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/DueDate/NextAppointmentDate"
  
}) {
let eventActionDataDueDateValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.due_date',
})
let constantData = 'next_appointment_date'
let aggregateData = fromAggregate.equals(eventActionDataDueDateValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="event_action.data.due_date"
 data="'next_appointment_date'"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 onClick={onClick}
 text="Next appointment date"
/>
{children}
</React.Fragment>)
}